import Loadable from 'react/components/loadable';

const DashboardV2Header = Loadable({
  loader: () => import('../../pages/dashboard/components/dashboard_v2_header'),
});

angular.module('gym').value('DashboardV2Header', DashboardV2Header);
